import React from 'react';
import type { ScreenMeta } from '../types/study';
type ProgressRailProps = {
  screens: ScreenMeta[];
  current: number;
};
export function ProgressRail({
  screens,
  current
}: ProgressRailProps) {
  return <div className="flex items-center gap-1.5" role="progressbar" aria-valuemin={1} aria-valuemax={screens.length} aria-valuenow={current + 1} aria-valuetext={screens[current].label} data-id="element-65" data-mp="1yvctzatc0jvk">
      {screens.map((s, i) => <span key={s.id} className={`h-[3px] w-5 rounded-full transition-colors duration-200 ease-out md:w-7 ${i < current ? 'bg-ink' : i === current ? 'bg-accent' : 'bg-hairline'}`} data-id="element-66" data-mp="1txbbos3qcol5" data-mpi={i} />)}
    </div>;
}